import Loader from 'components/Loader';
import HomeScreen from 'components/PhoneBoothScreen/Home/HomeScreen';
import StatusScreen from 'components/PhoneBoothScreen/Status/StatusScreen';
import Web3Provider from 'components/Web3Provider';
import { BlockNumberProvider } from 'hooks/useBlockNumber';
import { LanguageProvider } from 'i18n';
import { Suspense } from 'react';
import { Provider } from 'react-redux';
import { createRoutesFromElements, Outlet, Route } from 'react-router-dom';
import store from 'state';
import styled from 'styled-components/macro';
import ThemeProvider, { ThemedGlobalStyle } from 'theme';

import ErrorBoundary from '../components/ErrorBoundary';
import ApplicationUpdater from '../state/application/updater';
import { MulticallUpdater } from '../state/multicall/updater';
import Home from './Home/Home';

const AppWrapper = styled.div``;

const BodyWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;
  z-index: 1;
  width: 100%;
`;
export const routerRoutes = createRoutesFromElements(
  <Route path="/" element={<App />}>
    <Route path="/" element={<Home />}>
      <Route path="*" element={<HomeScreen />} />
      <Route path="status" element={<StatusScreen />} />
    </Route>
  </Route>
);

function Updaters() {
  return (
    <>
      <ApplicationUpdater />
      <MulticallUpdater />
    </>
  );
}

export default function App() {
  return (
    <Provider store={store}>
      <LanguageProvider>
        <Web3Provider>
          <BlockNumberProvider>
            <Updaters />
            <ThemeProvider>
              <ThemedGlobalStyle />
              <ErrorBoundary>
                <AppWrapper>
                  <BodyWrapper>
                    <Suspense fallback={<Loader />}>
                      <Outlet />
                    </Suspense>
                  </BodyWrapper>
                </AppWrapper>
              </ErrorBoundary>
            </ThemeProvider>
          </BlockNumberProvider>
        </Web3Provider>
      </LanguageProvider>
    </Provider>
  );
}
